import { render, staticRenderFns } from "./AdjustWalletBalance.vue?vue&type=template&id=42cf34db&"
import script from "./AdjustWalletBalance.vue?vue&type=script&lang=ts&"
export * from "./AdjustWalletBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports